// HMD Reported State Display Text Colors
const white = '#ffffff';
const cyan = '#2486C1';
const yellow = '#B07A3D';

export const HmdDisplays = {
  APFR: {
    line1: 'APFR: ', line2: '', line3: '', line1Color: white, line2Color: cyan, line3Color: cyan,
  },
  BOLT: {
    line1: 'BOLTS: ', line2: '', line3: '', line1Color: white, line2Color: cyan, line3Color: cyan,
  },
  CUSTOM: {
    line1: '', line2: '', line3: '', line1Color: white, line2Color: white, line3Color: white,
  },
  DARK: {
    line1: '', line2: '', line3: '', line1Color: '', line2Color: '', line3Color: '',
  },
  DEFAULT: {
    line1: 'Welcome', line2: 'to your', line3: 'HMD!', line1Color: cyan, line2Color: cyan, line3Color: cyan,
  },
  FLUID: {
    line1: 'FLUID QD: ', line2: '', line3: '', line1Color: white, line2Color: cyan, line3Color: cyan,
  },
  'MET-PET': {
    line1: '0%', line2: '00:00', line3: '', line1Color: yellow, line2Color: white, line3Color: '',
  },
  'MET-RATE': {
    line1: 'Met Rate', line2: '0', line3: 'BTU/Hr', line1Color: cyan, line2Color: yellow, line3Color: cyan,
  },
  'MET-RATE-PERCENT': {
    line1: 'Met Rate %', line2: '0%', line3: '', line1Color: cyan, line2Color: yellow, line3Color: '',
  },
  PET: {
    line1: 'PET', line2: '0:00', line3: '', line1Color: white, line2Color: white, line3Color: white,
  },
  PGT: {
    line1: '', line2: '', line3: '', line1Color: yellow, line2Color: yellow, line3Color: yellow,
  },
  TIMER1: {
    line1: 'TIMER 1', line2: '00:00', line3: '', line1Color: white, line2Color: white, line3Color: white,
  },
  TIMER2: {
    line1: 'TIMER 2', line2: '00:00', line3: '', line1Color: white, line2Color: white, line3Color: white,
  },
  NZGL: {
    line1: 'NZGL: ', line2: '', line3: '', line1Color: white, line2Color: cyan, line3Color: cyan,
  },
};

export default {
  HmdDisplays,
};
